export default {
  SET_INTERCOM(state, intercom) {
    state.intercom = intercom;
  },
};
